var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.version===1)?_c('WechatMPCardV1'):_vm._e(),(_vm.version===2)?_c('WechatMPCardV2'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }